export const TicketDataEditorApiUrls = {
  getTicketForFallback: "ticket/GetTicketForFallback",
  updateTicketForFallback: "ticket/UpdateTicketForFallback",
  updateTicketDeadlineForFallback: "ticket/UpdateTicketDeadlineForFallback",
  refreshApplicationResultForFallback: "ticket/RefreshApplicationResultForFallback",
};

export default class ticketDataEditorAPI {
  constructor(httpsClient, cache) {
    this.httpsClient = httpsClient;
    this.cache = cache;
  }

  async getTicketForFallback(data, token) {
    return this.get(TicketDataEditorApiUrls.getTicketForFallback, data, token);
  }

  async updateTicketDeadlineForFallback(data, token) {
    return this.get(TicketDataEditorApiUrls.updateTicketDeadlineForFallback, data, token);
  }

  async refreshApplicationResultForFallback(data, token) {
    return this.get(TicketDataEditorApiUrls.refreshApplicationResultForFallback, data, token);
  }

  async updateTicketForFallback(data, token) {
    return this.post(TicketDataEditorApiUrls.updateTicketForFallback, data, token);
  }

  async get(url, data, token, eAlert, sAlert) {
    return await this.httpsClient.get(url, data, token, eAlert, sAlert);
  }

  async post(url, data, token, eAlert, sAlert) {
    this.cache.remove("tests");

    return await this.httpsClient.post(url, data, token, eAlert, sAlert);
  }
}
